(function(){
    'use strict';

    angular.module('app').
    controller('ActionLogModalController', ActionLogModalController);

    ActionLogModalController.$inject=[
        '$uibModalInstance',
        'data'
    ]

    function ActionLogModalController($uibModalInstance,data){
        const vm = this;
        vm.dismiss = modalDismiss;
        vm.data = data;
        
        console.log(data)
        function modalDismiss(){
            $uibModalInstance.close()
        }

        
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/administration/modal/actionLogDetailsController.js